module.exports = __webpack_public_path__ + "img/copy-icon.d579b43a.svg";